import { render } from "./Sso.vue?vue&type=template&id=e9f20a28&scoped=true"
import script from "./Sso.vue?vue&type=script&lang=js"
export * from "./Sso.vue?vue&type=script&lang=js"

import "./Sso.vue?vue&type=style&index=0&id=e9f20a28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9f20a28"]])

export default __exports__